import styles from './styles.module.scss'
import { Avatar } from 'shared/ui/Avatar'
import { Typography } from 'shared/ui/Typography'

export const NewConversationCard = () => {
  return (
    <div className={styles.wrap}>
      <Avatar />
      <Typography variant={'s2-medium'} color={'--primary-color-gray-1'}>
        New conversation
      </Typography>
    </div>
  )
}
